module.exports = __webpack_public_path__ + "static/img/dahanLOGO.3bb82ff.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/mob/dahanLOGO.svg
// module id = Hl29
// module chunks = 0